import { render, staticRenderFns } from "./GenericListedCard.vue?vue&type=template&id=2dff5735&scoped=true"
import script from "./GenericListedCard.vue?vue&type=script&lang=js"
export * from "./GenericListedCard.vue?vue&type=script&lang=js"
import style0 from "./GenericListedCard.vue?vue&type=style&index=0&id=2dff5735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff5735",
  null
  
)

export default component.exports